import { WorkHours } from '../../models/warehouse-models';
import { MaterialBranch, NewRequestBranch } from '../../models/dashboard-models';

export const defaultSelectedClient = {
    companyName: '',
    country: '',
    ddc: false,
    vat: '',
    vatPrefix: '',
    city: '',
    mainGroup: '',
    companyAddress: '',
    owner: '',
    eik: '',
    phone: '',
    email: '',
    contact: '',
    company: true,
    hasDays: false,
    invoiceText: '',
    documentNumber: '',
};

export const defaultSelectedBranch: NewRequestBranch = {
    name: '',
    assignedDistributor: undefined,
    groupName: '',
    phone: '',
    contact: '',
    imgUrl: '',
    location: {
        latitude: '',
        longitude: '',
        address: '',
        city: '',
    },
    email: '',
    activity: '',
    state:'',
    isCompany: true,
    nextMaintenanceDate: '',
};
export const deviceWorkHours = {
    sprayRange: 40,
    waitRange: 200,
    startTime: '08:00',
    endTime: '20:00',
    weekDaysBoolean: {
        monday: true,
        tuesday: true,
        wednesday: true,
        thursday: true,
        friday: true,
        saturday: true,
        sunday: true,
    },
};

export const defaultDevice = {
    deviceName: '',
    inventoryNumber: '',
    batchNumber: '',
    warehouseDeviceId: 0,
    passportId: 0,
    model: '',
    oilName: '',
    oilType: '',
    workHoursList: [deviceWorkHours] as WorkHours[],
    materials: [] as MaterialBranch[]
};

export const invoiceOptions = [
    { name: 'bankWithInvoiceByMail', value: 'BANK_WITH_INVOICE_BY_MAIL' },
    { name: 'bankWithInvoiceByHand', value: 'BANK_WITH_INVOICE_BY_HAND' },
    { name: 'bankWithBill', value: 'BANK_WITH_BILL' },
    { name: 'cashWithInvoiceByHand', value: 'CASH_WITH_INVOICE_BY_HAND' },
    { name: 'cashWithReceipt', value: 'CASH_WITH_RECEIPT' },
];
